<template>
  <section class="hero-section">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <img
        src="@/assets/images/Logo-withoutbg.png"
        alt="Clients Preferred Property Hub Logo"
        class="hero-logo animate-up"
      />

      <h1 class="hero-title animate-up delay-1">
        Your Journey Home Begins Here
      </h1>
      <p class="hero-subtitle animate-up delay-2">
        Expert real estate guidance across Chandigarh, Mohali, Kharar, and
        Panchkula.
      </p>

      <!--
      <div class="search-container animate-up delay-3">
        <input
          type="text"
          placeholder="Search by City, Neighborhood, or MLS#..."
          class="search-input"
        />
        <button class="search-button">
          <span>SEARCH</span>
        </button>
      </div>
      -->
    </div>
  </section>
</template>

<style scoped>
.hero-section {
  position: relative;
  height: 85vh;
  min-height: 750px;
  background: url('https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1600')
    center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3));
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 900px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* RESPONSIVE LOGO STYLING */
.hero-logo {
  height: clamp(200px, 30vw, 300px);
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1) drop-shadow(0 4px 10px rgba(0, 0, 0, 0.3));

  margin-bottom: 0px !important;
}

.hero-title {
  font-size: clamp(2.2rem, 5vw, 4rem);
  font-weight: 800;
  margin-top: -20px !important;
  margin-bottom: 10px;
  line-height: 1.1;
  color: white;
}

.hero-subtitle {
  font-size: clamp(1rem, 2vw, 1.25rem);

  font-weight: 300;
  opacity: 0.9;
  color: white;
  max-width: 600px;
}

.search-container {
  background: white;
  padding: 5px; /* Slightly reduced padding */
  border-radius: 50px;
  display: flex;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 600px;
}

.search-input {
  flex: 1;
  border: none;
  padding: 15px 20px;
  font-size: 1rem;
  outline: none;
  border-radius: 50px;
  color: #333;
  min-width: 0; /* Important for flex child overflow */
}

.search-button {
  background: #b91c1c;
  color: white;
  border: none;
  padding: 0 25px; /* Adjusted padding */
  border-radius: 50px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
  white-space: nowrap; /* Prevents text wrapping */
}

.search-button:hover {
  background: #991b1b;
}

/* Animations */
.animate-up {
  animation: fadeInUp 0.8s ease forwards;
  opacity: 0;
}
.delay-1 {
  animation-delay: 0.2s;
}
.delay-2 {
  animation-delay: 0.4s;
}
.delay-3 {
  animation-delay: 0.6s;
}

@keyframes fadeInUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
